import React, { Component } from 'react';
import Order from '../Components/Order/Order';
import queryString from 'query-string';
import axios from 'axios';
import Common from '../Components/Common/common.js';
// import VConsole from 'vconsole';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      siteId: props.match.params.siteId,
      liff_access_token: null,
      liff_user_id: null,
      channel_id: null,
      page: null,
      open_data: null,
      my_order: null,
      current_order: null,
    };

    this.liff_init = this.liff_init.bind(this);
  }

  liff_init() {
    if (window.liff.isInClient() && window.liff.isLoggedIn()) {
      const accessToken = window.liff.getAccessToken();
      const decodedId = window.liff.getDecodedIDToken();
      this.setState({
        liff_access_token: accessToken,
        liff_user_id: decodedId.sub
      });
    } else {
      this.setState({
        liff_access_token: 'token_unusable',
        liff_user_id: 'test_user_id'
      });
    }
  }

  setPage(page) {
    this.setState({ page: page });
  }

  setCurrentOrder(current_order) {
    this.setState({ current_order: parseInt(current_order) });
    }

  setOpenData(open_data) {
    this.setState({ open_data: open_data });
  }

  setMyOrder(order) {
    this.setState({ my_order: order });
  }

  async componentDidMount() {
    var qs = queryString.parse(this.props.location.search);
    this.setState({ channel_id: qs.channel, page: qs.page, current_order: parseInt(qs.current_order), plan_id: parseInt(qs.plan_id)  });
    if (process.env.REACT_APP_ENV !== 'dev') {
      if (window.liff.id === null) {
        var liffId;
        const settings = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/setting/${this.state.siteId}`)).data; // 設定マスタ取得
        liffId = Common.getSettingValue(settings, 'API_LIFF_ID', '')
        window.liff.init({ liffId: liffId });
      }
      window.liff.ready.then(this.liff_init);
    } else {
      this.liff_init();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      var qs = queryString.parse(this.props.location.search);
      this.setState({ channel_id: qs.channel, page: qs.page, current_order: Number(qs.current_order), plan_id: Number(qs.plan_id) });
    }
  }

  render() {
    return (
      <Order
        liff_access_token={this.state.liff_access_token}
        liff_user_id={this.state.liff_user_id}
        channel_id={this.state.channel_id}
        page={this.state.page}
        setPage={(page) => { this.setPage(page); }}
        current_order={this.state.current_order}
        setCurrentOrder={(current_order) => { this.setCurrentOrder(current_order); }}
        plan_id={this.state.plan_id} />
    );
  }
}

export default App;